import { matchPath } from "react-router-dom";

// 导航状态唯一来源是 URL（重构 Phase 1a，方案见 docs/sdd/frontend-architecture-refactor/plan.md）：
// /                          登录后替换到 /overview
// /overview                   持有标的、关注标的与主要指数
// /tag/:name                 标签汇总页（name 做 URL 编码）
// /screener                  添加关注：自然语言查找标的（A股 / ETF / 场外基金）
// /single                   单标的核算 Agent（?asset= 时自动让 Agent 打开该标的行情）
// /market                    大盘观察
// /rank                      基础事实选股
// /industry[/flow]           申万板块涨跌 / 资金流
// /industry/:id              行业详情
// /stock/:code               指数/个股详情（分时、日K、周K、月K、年K）

export function deriveRoute(location) {
  const path = location.pathname;
  const query = new URLSearchParams(location.search);
  const base = {
    mode: "market", screen: "market_overview", portfolioListMode: false, portfolioIds: [],
    activeTab: "overview", collectionId: null, collectionTab: "overview", bareBoard: false,
    industryCode: null, instrumentCode: null, instrumentReturnTo: null,
    singleConversationId: null, singleBindingId: null, singleAssetQuery: null,
    singleHoldingId: null, singleWorkspaceId: null, tagName: null,
  };
  let m;
  if (path === "/overview") {
    return { ...base, mode: "asset_overview", screen: "asset_overview" };
  }
  if (path === "/screener") {
    return { ...base, mode: "screener", screen: "screener" };
  }
  if ((m = matchPath("/tag/:name", path))) {
    // matchPath 不解码参数，而标签名是中文，pathname 里是百分号编码。
    let tagName = m.params.name;
    try { tagName = decodeURIComponent(tagName); } catch { /* 畸形编码原样交给接口，得到空态 */ }
    return { ...base, mode: "tag_summary", screen: "tag_summary", tagName };
  }
  if (path === "/single") {
    if (!query.get("binding") && !query.get("asset") && !query.get("holding") && !query.get("workspace")) {
      return {
        ...base,
        mode: "asset_overview",
        screen: "asset_overview",
        redirectTo: "/overview",
      };
    }
    return {
      ...base,
      mode: "single_asset_agent",
      screen: "single_asset_agent",
      singleConversationId: query.get("conversation"),
      singleBindingId: query.get("binding"),
      singleAssetQuery: query.get("asset"),
      singleHoldingId: query.get("holding"),
      singleWorkspaceId: query.get("workspace"),
    };
  }
  if (import.meta.env?.DEV && path === "/dev/single-asset-agent") {
    return { ...base, mode: "single_asset_agent", screen: "single_asset_agent" };
  }
  if (path === "/market" && query.get("asset")) {
    return {
      ...base,
      mode: "market",
      screen: "instrument_detail",
      instrumentCode: query.get("asset"),
      instrumentReturnTo: query.get("from") || "/overview",
    };
  }
  if (path === "/market") return { ...base, mode: "market", screen: "market_overview" };
  if (path === "/rank") return { ...base, mode: "market", screen: "market_rank" };
  if (path === "/industry") return { ...base, mode: "market", screen: "industry_list" };
  if (path === "/industry/flow") return { ...base, mode: "market", screen: "industry_flow" };
  if ((m = matchPath("/industry/:id", path))) {
    return { ...base, mode: "market", screen: "industry_detail", industryCode: m.params.id };
  }
  if ((m = matchPath("/stock/:code", path))) {
    return {
      ...base,
      mode: "market",
      screen: "instrument_detail",
      instrumentCode: m.params.code,
      instrumentReturnTo: query.get("from"),
    };
  }
  return { ...base, redirectTo: "/overview" };
}
